import React from "react";
import styled from "styled-components";
import { I18n } from "@lingui/react";
import { DataGridHeading, Main, Badge } from "@conserveit/blocks";
import { analysisColumns } from "../../../../utils/columns";
import SortArrow from "../../../SortArrow";
import { GroupHeaderProps as Props } from "../../utils";
import { useState as useAnalysisState } from "../../../../context/analysis";

const StyledHeading = styled(DataGridHeading)`
  white-space: nowrap;
`;

const RuleGroupHeader: React.FunctionComponent<Props> = ({
  activeSort,
  hitCount,
  equipCount,
  groupCount,
  sortDirection,
  onSort,
}) => {
  const { viewMode } = useAnalysisState();
  const cols = analysisColumns[viewMode];

  return (
    <I18n>
      {({ i18n }) => (
        <React.Fragment>
          <StyledHeading
            minWidth={cols.LATEST.minWidth}
            onClick={() => onSort(cols.LATEST.key)}
          >
            <Main>
              {cols.LATEST.label(i18n)}
              {activeSort === cols.LATEST.key && (
                <SortArrow direction={sortDirection} />
              )}
            </Main>
          </StyledHeading>
          <StyledHeading
            minWidth={cols.SITE.minWidth}
            onClick={() => onSort(cols.SITE.key)}
          >
            <Main>
              {cols.SITE.label(i18n)} <Badge>{groupCount}</Badge>
              {activeSort === cols.SITE.key && (
                <SortArrow direction={sortDirection} />
              )}
            </Main>
          </StyledHeading>
          <StyledHeading
            minWidth={cols.REGION.minWidth}
            onClick={() => onSort(cols.REGION.key)}
          >
            <Main>
              Region
              {activeSort === cols.REGION.key && (
                <SortArrow direction={sortDirection} />
              )}
            </Main>
          </StyledHeading>
          <StyledHeading
            minWidth={cols.AFFECTED_EQUIPS.minWidth}
            onClick={() => onSort(cols.AFFECTED_EQUIPS.key)}
          >
            <Main>
              {cols.AFFECTED_EQUIPS.label(i18n)} <Badge>{equipCount}</Badge>
              {activeSort === cols.AFFECTED_EQUIPS.key && (
                <SortArrow direction={sortDirection} />
              )}
            </Main>
          </StyledHeading>
          <StyledHeading
            minWidth={cols.TRIGGERED_RULES.minWidth}
            onClick={() => onSort(cols.TRIGGERED_RULES.key)}
          >
            <Main>
              {cols.TRIGGERED_RULES.label(i18n)} <Badge>{hitCount}</Badge>
              {activeSort === cols.TRIGGERED_RULES.key && (
                <SortArrow direction={sortDirection} />
              )}
            </Main>
          </StyledHeading>
        </React.Fragment>
      )}
    </I18n>
  );
};

export default RuleGroupHeader;
